import { InputHTMLAttributes } from 'react';
import Form from '.';
import { InputProps } from '../Input';

interface FormLinkProps extends InputHTMLAttributes<HTMLLabelElement> {}

export default function FormLink({
  children,
  className = '',
  ...rest
}: FormLinkProps) {
  return (
    <label className={`form-link ${className}`} {...rest}>
      {children}
    </label>
  );
}
